(() => {
  const pickerSelector = 'variant-picker[data-lrc-require-selection="true"]';
  const purchaseSelector = 'add-to-cart-component button, button[name="add"], sticky-add-to-cart [ref="addToCartButton"], .zakeke-product-button, #zakeke-product-button, .shopify-payment-button, shopify-accelerated-checkout';
  let queued = false;

  function getPicker(target) {
    const root = target.closest('quick-add-dialog, dialog, featured-product-information, .shopify-section, product-card');
    return root?.querySelector(pickerSelector)
      || (target.closest('sticky-add-to-cart') ? document.querySelector(`${pickerSelector}[data-template-product-match="true"]`) : null);
  }

  function isReady(picker) {
    return picker.dataset.lrcSelectionReady === 'true';
  }

  function sync() {
    queued = false;
    for (const button of document.querySelectorAll(purchaseSelector)) {
      const picker = getPicker(button);
      if (!picker) continue;
      const root = picker.closest('quick-add-dialog, dialog, featured-product-information, .shopify-section, product-card');
      const blocked = !isReady(picker);
      if (root && root.dataset.lrcPurchaseBlocked !== String(blocked)) root.dataset.lrcPurchaseBlocked = String(blocked);
      if (blocked) {
        if (button.dataset.lrcSelectionDisabled !== 'true') button.dataset.lrcSelectionDisabled = 'true';
        if (button.getAttribute('aria-disabled') !== 'true') button.setAttribute('aria-disabled', 'true');
        if ('disabled' in button && !button.disabled) button.disabled = true;
      } else if (button.dataset.lrcSelectionDisabled === 'true') {
        delete button.dataset.lrcSelectionDisabled;
        const variant = JSON.parse(picker.querySelector('script[type="application/json"]')?.textContent || 'null');
        const unavailable = !variant?.available || button.dataset.lrcZakekeDisabled === 'true';
        if ('disabled' in button) button.disabled = unavailable;
        if (unavailable) button.setAttribute('aria-disabled', 'true');
        else button.removeAttribute('aria-disabled');
      }
    }
  }

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(sync);
  }

  window.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target.closest(purchaseSelector) : null;
    if (!target) return;
    const picker = getPicker(target);
    if (!picker || isReady(picker)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const control = Array.from(picker.querySelectorAll('select')).find((select) => !select.value && !select.closest('.variant-option')?.hidden);
    control?.focus();
  }, true);

  window.addEventListener('submit', (event) => {
    if (!(event.target instanceof HTMLFormElement) || !event.target.action.includes('/cart/add')) return;
    const picker = getPicker(event.target);
    if (!picker || isReady(picker)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  document.addEventListener('lrc:selection-state', sync);
  document.addEventListener('variant:update', schedule);
  document.addEventListener('shopify:section:load', schedule);
  new MutationObserver(schedule).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['disabled', 'aria-disabled'],
  });
  sync();
})();
